import React from 'react';

import { StyledToastContainer } from './ToastContainer.styles';

export const ToastContainer = () => <StyledToastContainer />;
